export const IMEI_STATUESES = [
    { name: 'OK', label: 'OK', value: 'OK' },
    { name: 'Barred', label: 'Barred', value: 'Barred' }
]